import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, MessagesSquare } from "lucide-react";
import api from "../lib/api";
import Reveal from "./Reveal";

export default function LoungeTeaser() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/community/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <section data-testid="lounge-teaser" className="border-y border-white/10 bg-white/[0.02]">
      <div className="max-w-[1440px] mx-auto px-5 lg:px-10 py-20 lg:py-28">
        <Reveal>
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10">
            <div className="max-w-2xl">
              <p className="text-xs font-mono uppercase tracking-[0.3em] text-kinetic mb-4 flex items-center gap-2">
                <MessagesSquare size={14} /> Live now
              </p>
              <h2 className="font-display font-black uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight">
                The Lounge — <span className="font-serif italic normal-case text-ash">talk it out</span>
              </h2>
              <p className="text-ash mt-5 leading-relaxed max-w-xl">
                One open room for every reader of the magazine. Cars at dawn, tattoos at midnight —
                whatever's on your mind, someone's awake for it.
              </p>
            </div>
            <div className="flex flex-col items-start lg:items-end gap-5 shrink-0">
              <div data-testid="lounge-teaser-count" className="flex items-center gap-3">
                <span className="relative flex h-2.5 w-2.5">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-kinetic opacity-60"></span>
                  <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-kinetic"></span>
                </span>
                <span className="font-display font-extrabold text-2xl sm:text-3xl tracking-tight tabular-nums">
                  {stats ? stats.members.toLocaleString() : "—"}
                </span>
                <span className="text-[11px] font-mono uppercase tracking-[0.2em] text-ash">members and counting</span>
              </div>
              <Link to="/lounge" data-testid="lounge-teaser-cta"
                className="group flex items-center gap-2 bg-kinetic text-obsidian text-xs font-mono uppercase tracking-[0.18em] font-medium px-7 py-4 rounded-full hover:bg-porcelain transition-colors duration-300">
                Step into the Lounge
                <ArrowUpRight size={14} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" />
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
